import React, { useState } from 'react';
import { Button, Popover, Tooltip, Upload, message } from 'antd';
import { api } from 'react-structure-admin';
import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { FaQrcode } from 'react-icons/fa';
import SharingFileQRCode from './SharingFileQRCode';

const supportedTypes = ['image/jpeg', 'image/png'];

const UploadProfileImageV2 = ({ value, onChange, params }) => {
  const [loading, setLoading] = useState(false);
  const [openSharingQRCode, setOpenSharingQRCode] = useState(false);

  const handlerUploadError = () => {
    setLoading(false);
    message.error('Ocorreu um erro inesperado ao processar sua solicitação.');
  };

  const handleOnChange = (newFile) => {
    setLoading(false);
    onChange(newFile);
    setOpenSharingQRCode(null);
  };

  const customRequest = (options) => {
    setLoading(true);
    const data = new FormData();
    data.append('file', options.file);
    data.append('type', 'profile');

    if (params) {
      Object.keys(params).forEach((key) => {
        data.set(key, params[key]);
      });
    }

    options.file.status = 'uploading';

    api.post('archives', data).then((response) => {
      if (!(response && response.errors)) {
        handleOnChange(response.data.result);
        options.onSuccess(options.file, options.data);

        return;
      }

      options.onError();
      handlerUploadError();
    });
  };

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Carregar imagem</div>
    </button>
  );

  const handleRemove = () => {
    onChange(null);
  };

  const beforeUpload = (file) => {
    const allows = supportedTypes.includes(file.type);

    if (!allows) {
      message.error(
        `Esse tipo de arquivo (${file.type}) não é permitido para anexos.`
      );
      return false;
    }

    const isLt3M = file.size / 1024 / 1024 <= 3;

    if (!isLt3M) {
      message.error('O tamanho do arquivo não pode ser superior a 3MB!');
    }

    return isLt3M;
  };

  return (
    <div>
      {openSharingQRCode ? (
        <SharingFileQRCode
          onClose={() => setOpenSharingQRCode(false)}
          onNewUpload={handleOnChange}
          supportedTypes={supportedTypes}
        />
      ) : null}

      <Popover
        placement="bottom"
        content={
          <div>
            <Tooltip title="Recebe imagem de outro dispositivo">
              <Button
                icon={<FaQrcode />}
                onClick={() => setOpenSharingQRCode(true)}
              />
            </Tooltip>
            {value && (
              <Tooltip title="Remover">
                <Button icon={<DeleteOutlined />} onClick={handleRemove} />
              </Tooltip>
            )}
          </div>
        }
      >
        <div>
          <Upload
            name="avatar"
            className="avatar-uploader"
            listType="picture-card"
            showUploadList={false}
            customRequest={customRequest}
            beforeUpload={beforeUpload}
          >
            {value?.id ? (
              <img
                src={`${process.env.REACT_APP_API_URL}/archives/${value.id}/binary`}
                alt="avatar"
                style={{ width: '100%' }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </div>
      </Popover>
    </div>
  );
};

export default UploadProfileImageV2;
